import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../common/Modal/Modal';
import '../SendReceiveSidePane/SendReceiveTwoFactorAuth/SendReceiveTwoFactorAuthModal.css';
import APAutoTabInput from '../common/APAutoTabInput/APAutoTabInput';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import { required } from '../../helpers/formValidations';
var baseClasses = getBEMClasses('send-receive-two-factor-auth-modal');
var TwoFactorAuthModal = function TwoFactorAuthModal(props, context) {
  var handleSubmit = props.handleSubmit,
    isOpen = props.isOpen,
    close = props.close,
    error = props.error;
  return React.createElement(Modal, {
    isOpen: isOpen,
    title: context.t('Two-Factor Authentication'),
    onCancel: close,
    close: close
  }, React.createElement('form', {
    onSubmit: handleSubmit,
    className: baseClasses()
  }, React.createElement('div', {
    className: baseClasses('text-item')
  }, context.t('Enter the token from your Authenticator app.')), React.createElement(APAutoTabInput, {
    name: 'code',
    type: 'input',
    numberOfInputs: 6,
    validate: [required]
  }), React.createElement('div', {
    className: baseClasses('footer')
  }, React.createElement('div', {
    className: error && baseClasses('text-item__failed')
  }, error && context.t(error)))));
};
TwoFactorAuthModal.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};
TwoFactorAuthModal.propTypes = {
  close: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func
};
TwoFactorAuthModal.contextTypes = {
  t: PropTypes.func.isRequired
};
export default TwoFactorAuthModal;